import React from 'react';
import StatsTile from '../../../core/form/components/StatsTile';
import {
  Row
} from 'reactstrap';

const ResourceUsageHoursTiles = (props) => {
  const {
    data,
    orgs
  } = props;

  const keys = Object.keys(data);
  const tiles = keys.map((key, index) => {
    const colour = orgs.find(org => org.name === key).colour;
    return (
      <StatsTile key={index} bottomStyles={{backgroundColor: colour}} value={data[key]} unit={' hours'} title={`${key} - Total Hours`} />
    )
  })

  return (
    <div className="p-1 text-center">
      <Row className="d-flex justify-content-center bg-light p-2">
        {tiles}
      </Row>
    </div>
  );
}

export default ResourceUsageHoursTiles;
